<script setup lang="ts">
const props = defineProps<{
  formId: string
}>()

const { targetId, failure } = useHubspotForm(props.formId)
</script>

<template>
  <div
    :id="targetId"
    class="py-4 rounded-xs bg-icssilver-50 w-full f-px-8-16 dark:bg-icssilver"
  >
    <div
      v-if="failure"
      class="text-icssilver-950 text-center relative"
    >
      <span class="i-carbon-warning text-icsred m-12 inline-block scale-140" />
      <p>There was an error loading the form.</p>
      <p>Feel free to call or email us directly.</p>
      <p class="mt-4">
        1-720-652-6777
      </p>
      <p>sales@ics-mfg.com</p>
    </div>
    <div
      v-else
      class="text-icssilver-950 text-center relative"
    >
      <span class="i-svg-spinners-bars-scale-middle text-icsblue m-12 inline-block dark:text-icscyan" />
      <p>Loading Form...</p>
    </div>
  </div>
</template>
